import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { RestGeneric } from '../rest.generic';
import { HttpClient } from '@angular/common/http';
import { RestGenericUtilService } from '../rest-generic-util.service';
import { AuthFactoryService } from '../../auth/auth-factory.service';

@Injectable({
  providedIn: 'root'
})
export class DefaultActivityService extends RestGeneric<any, any, any> {
  constructor(
    protected http: HttpClient,
    protected authFactoryService: AuthFactoryService,
    protected restGenericUtilService: RestGenericUtilService
  ) {
    super(http, authFactoryService, 'main-activity-list', restGenericUtilService);
  }

  addActivityInDefaultActivityList(requestData: any): Observable<any> {
    return this.http.put<any>(`${this.baseApiUrl}/${this.schoolUUid}/default-activity-list/activity`, requestData);
  }

  deleteActivityInDefaultActivityList(requestData: any): Observable<any> {
    return this.http.delete<any>(`${this.baseApiUrl}/${this.schoolUUid}/default-activity-list/activity`, { body: requestData});
  }

  handleCheckBoxToggle(requestData:any) : Observable<any>{
    if(requestData.status){
      return this.http.put<any>(`${this.baseApiUrl}/${this.schoolUUid}/main-activity-list/${requestData.selectedListUUID}/activity/${requestData.selctedActivityUUID}`, requestData);
    }else{
      return this.http.delete<any>(`${this.baseApiUrl}/${this.schoolUUid}/main-activity-list/${requestData.selectedListUUID}/activity/${requestData.selctedActivityUUID}`, requestData);
    }
  }

  getConflictingActivities(requestData:any) : Observable<any>{
    const params = this.restGenericUtilService.toParams({undefined, ...requestData });

    return this.http.get(`${this.baseApiUrl}/${this.schoolUUid}/default-activity-list/conflicts`, {
      params
    });
  }

  getAllMappedListAndActivities() : Observable<any>{
    return this.http.get(`${this.baseApiUrl}/${this.schoolUUid}/default-activity-list/fetch-activity-list`);
  }

  renameDefaultActivityList(updateType: any, uuid: string): Observable<any>{
    return this.http.put<any>(`${this.baseApiUrl}/${this.schoolUUid}/${this.endpointName}/${uuid}`, updateType);
  }

  deleteDefaultActivityList(uuid: string): Observable<any> {
    return this.http.delete<any>(`${this.baseApiUrl}/${this.schoolUUid}/${this.endpointName}/${uuid}`)
  }

  scheduleActivitiesFromDefaultList(requestType: any): Observable<any> {
    return this.http.post<any>(`${this.baseApiUrl}/${this.schoolUUid}/default-activity-list/schedule/activities`, requestType);
  }

  getAllActivities(requestData:any): Observable<any> {
    const params = this.restGenericUtilService.toParams({undefined, ...requestData });
    return this.http.get(`${this.baseApiUrl}/${this.schoolUUid}/activity`,{
      params
    });
  }
}